import { render } from "./TableHeader.vue?vue&type=template&id=72681f14&ts=true"
import script from "./TableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72681f14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72681f14', __exports__)) {
    api.reload('72681f14', __exports__)
  }
  
  module.hot.accept("./TableHeader.vue?vue&type=template&id=72681f14&ts=true", () => {
    api.rerender('72681f14', render)
  })

}


export default __exports__